import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {RETURN, SPACE} from 'shells/utils/keys';

import {appHistory} from '../../../../../history';

import {Link} from '../link/link';

import styles from './preview-with-edit.module.css';

type Props = {
    to: string;
    preview: React.ReactNode;
    noun: 'form' | 'page';
    backgroundColor?: string;
};

export function PreviewWithEdit(props: Props) {
    const handleClick = () => appHistory.push(props.to);

    // @ts-expect-error
    const handleKeyDown = (e) => {
        if (e.keyCode === RETURN || e.keyCode === SPACE) {
            handleClick();
        }
    };

    return (
        <div className={styles['preview-container']}>
            <div
                // @ts-expect-error
                tabIndex='0'
                onKeyDown={(e) => handleKeyDown(e)}
                style={{backgroundColor: props.backgroundColor}}
                className={styles.preview}
            >
                {props.preview}
            </div>
            <div onClick={handleClick} className={styles['preview-overlay']}>
                {/* @ts-expect-error */}
                <Link as={RoutedLink} size='big' variant='button-primary' to={props.to}>
                    Edit {props.noun}
                </Link>
            </div>
        </div>
    );
}
